import { UPDATE_SEARCHTDATA_TICKET } from "../../actions/Ticket/actionTypes";

const initialState = {
  trangThai: -1,
  tieude:"",
  pageIndex: 1,
  pageSize: 25,
  ListDaTicket: [],
};

const updateDataSearch = (state, action) => ({
  ...action.payload,

  //matentaisan: action.payload.matentaisan,
  //searchText: action.payload,
});

export const dataSearchTicket = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_SEARCHTDATA_TICKET:
      return updateDataSearch(state, action);
    default:
      return state;
  }
};

export default dataSearchTicket;
